import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { EventDetailSetting } from "../../../actions/auth";
import { useDispatch } from "react-redux";
import { MY_PROFILE } from "../../../actions/types";
const SettingsContent = ({ id }) => {
  const dispatch = useDispatch();
  const [settingData, setSettingData] = useState({});
  const [popupImage, setPopupImage] = useState("");
  useEffect(() => {
    dispatch(EventDetailSetting(id)).then((res) => {
      if (res.success) {
        setSettingData(res.data);
      }
    });
  }, []);
  return (
    <>
      <div className="SettingContentWrap">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-4 col-md-4 col-sm-12 col-12 pl-0 ">
              <div className="form-group">
                <label for="exampleFormControlSelect1" className="inputlabel">
                  Event Status
                </label>
                <select
                  className="form-control eventsStatus"
                  id="exampleFormControlSelect1"
                >
                  <option>Published</option>
                  <option>Draft</option>
                </select>
              </div>
              <div className="settingLabel">
                <h4 className="mb-0 inputlabel">Date & Time </h4>
                <p className="Text">{settingData.event_date}</p>
                <p className="Text"> at {settingData.event_time}</p>
              </div>
              <div className="settingLabel">
                <h4 className="mb-0 inputlabel">Event Location </h4>
                <p className="Text">{settingData.location}</p>
              </div>
              <div className="settingLabel">
                <h4 className="mb-0 inputlabel">Description</h4>
                <p className="Text">{settingData.description} </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-12 col-12">
              <div className="settingLabel">
                <h4 className="mb-0 inputlabel">Party ID</h4>
                <p className="Text">
                  #{settingData._id && settingData._id.slice(0, 5)}
                </p>
              </div>
              <div className="settingLabel">
                <h4 className="mb-0 inputlabel">Name</h4>
                <p className="Text">{settingData.title}</p>
              </div>

              <div className="form-group mb-0">
                <label className="mb-0 inputlabel">Event Images</label>
                <div className="d-flex">
                  <div class="row">
                    {settingData.event_images &&
                      settingData.event_images.map((rr) => {
                        return (
                          <div class="col-lg-3 col-sm-3 col-md-3 col-12 p-1 mb-2">
                            <a
                              href="#"
                              data-toggle="modal"
                              data-target="#exampleModal"
                              onClick={() => setPopupImage(rr)}
                            >
                              <div className="image-wrapppp">
                                <img
                                  src={`${MY_PROFILE}/${rr}`}
                                  className="event-img"
                                  onError={(e) => {
                                    e.target.onerror = null; // Prevent infinite loop in case `noImage.png` also fails
                                    e.target.src = "img/noImage.png"; // Fallback image if loading fails
                                  }}
                                ></img>
                              </div>
                            </a>
                          </div>
                        );
                      })}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-12 col-12">
              <div className="profile--image">
                <img
                  src={`${MY_PROFILE}/${settingData.hostImage}`}
                  alt="profile-img"
                  className="eventsProfile"
                  onError={(e) => {
                    e.target.onerror = null; // Prevent infinite loop in case `noImage.png` also fails
                    e.target.src = "img/noImage.png"; // Fallback image if loading fails
                  }}
                ></img>
                <h4 className="mb-0 inputlabel">
                  From: {settingData.hostname}
                </h4>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12 col-md-12 col-sm-12 col-12 text-center">
          <Link to="/events" className="cancel-btn mr-2">
            Cancel
          </Link>
          <Link to="#" className="save-btn ">
            Save Changes
          </Link>
        </div>
      </div>
      <div
        className="modal fade"
        id="exampleModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body images-gallery">
              <img
                src={`${MY_PROFILE}/${popupImage}`}
                class="event-lg-img"
                onError={(e) => {
                  e.target.onerror = null; // Prevent infinite loop in case `noImage.png` also fails
                  e.target.src = "img/noImage.png"; // Fallback image if loading fails
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default SettingsContent;
